import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useParams } from 'react-router-dom';
import { authService, templateService, customerService, referencePhotoService, suggestionListService } from '../../_services'
import { Row, Col, Button, Modal, Card, Tabs, Tab } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFolder, faSquareCheck, faCamera, faPaintbrush, faFont, faHashtag, faListCheck,
	faMinus, faPlus, faInfo, faPaperclip, faEdit, faGear, faHeading, faUsers, faBarcode, faFileExcel } from '@fortawesome/free-solid-svg-icons'
import { faCalendar, faClock, faMap } from '@fortawesome/free-regular-svg-icons'
import styles from './details.module.css';
import { history } from '../../_helpers';
import { SERVER_URL } from '../../config';
import moment from 'moment'
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer-continued'

function TemplateDetails() {

	const [template, setTemplate] = useState(null)
	const [tasks, setTasks] = useState([])
	const [customers, setCustomers] = useState([])
	const [referencePhotos, setReferencePhotos] = useState([])
	const [selectedTask, setSelectedTask] = useState(null)
	const [suggestionLists, setSuggestionLists] = useState([])
	const [templateBackups, setTemplateBackups] = useState([])
	const [leftTemplateBackup, setLeftTemplateBackup] = useState(null)
	const [rightTemplateBackup, setRightTemplateBackup] = useState(null)
	const [showModal, setShowModal] = useState(false)
	const [backdrop, setBackdrop] = useState(false)
	const {uuid} = useParams()
    const {t} = useTranslation('common')

    useEffect(() => {
        if (authService.hasRoles(['ROLE_SUPER_ADMIN'])) {
	        customerService.getOptions().then(data => {
	            setCustomers(data)
	        })
        }
        referencePhotoService.list().then(referencePhotos => {
			setReferencePhotos(referencePhotos)
        })
		templateService.get(uuid).then(template => {
			template.tasks.forEach(task => {
				task.expanded = true
				task.hasChildren = template.tasks.some(child => child.parent == task.id)
			})
			setTemplate(template)
			setTasks(template.tasks)

			templateService.getTemplateBackups(uuid).then(templateBackups => {
				setTemplateBackups(templateBackups)
				console.log(templateBackups.length)
				if (templateBackups.length == 1) {
					setLeftTemplateBackup(templateBackups[0])
					setRightTemplateBackup(templateBackups[0])
				} else if (templateBackups.length > 1) {
					setLeftTemplateBackup(templateBackups[templateBackups.length - 2])
					setRightTemplateBackup(templateBackups[templateBackups.length - 1])
				}
	        })
        })
        if (authService.hasRoles(['ROLE_SUGGESTION_LIST_READ'])) {
	        suggestionListService.list().then(suggestionLists => {
				setSuggestionLists(suggestionLists)
	        })
        }
    }, [])

    function showTaskTypes() {
        if (template && authService.hasRoles(['ROLE_SUPER_ADMIN'])) {
            let customer = customers.find(customer => customer.id == template.customerId)
			if (customer) {
				return customer.products.some(product => product.name === "FORM")
			}
        }
		return authService.hasProducts(['FORM'])
    }

    const getTaskOptions = (task) => {
        if (task.type == "SINGLE_CHOICE_SUGGESTION" || task.type == "MULTI_CHOICE_SUGGESTION" || task.type == "CONTACT_PERSONS") {
            var suggestionList = suggestionLists.find(suggestionList => suggestionList.id === task.options)
            if (suggestionList) {
                return suggestionList.name
            }
            return '-'
        }
        return task.options || '-'
    }

    const getTemplateTaskRow = (task, depth) => {
        return <React.Fragment key={task.id}>
			<tr>
				<td style={{paddingLeft: (12 + (25 * depth)) + 'px'}}>
					{ task.type == 'GROUP' && task.hasChildren &&
						<a onClick={e => toggleGroup(e, task)} style={{cursor: 'pointer', marginRight: '10px'}}>
							<FontAwesomeIcon icon={task.expanded ? faMinus : faPlus}/>
						</a>
					}
					{ task.type == 'GROUP' && !task.hasChildren &&
						<span style={{marginRight: '10px', color: 'lightgray'}}>
							<FontAwesomeIcon icon={faPlus}/>
						</span>
					}
					{getDocumentationTaskIcon(task)} {task.name}
				</td>
				<td>
					{task.key || '-'}
				</td>
				<td>
					{task.description || '-'}
				</td>
				{ showReferencePhotos() &&
					<td>
						{ task.referencePhotos.length == 0 &&
							<>-</>
						}
						{ task.referencePhotos.map(templateTaskReferencePhoto => {
							var referencePhoto = referencePhotos.find(referencePhoto => referencePhoto.id == templateTaskReferencePhoto.referencePhoto)
							return <React.Fragment key={templateTaskReferencePhoto.id}>
								<a href={SERVER_URL + "/referencePhoto/download/" + templateTaskReferencePhoto.referencePhoto} target="_blank">
									{referencePhoto ? referencePhoto.name : templateTaskReferencePhoto.id}
								</a>
								&nbsp;
							</React.Fragment>
						})}
					</td>
				}
				<td style={{ whiteSpace: 'pre-line' }}>
					{ getTaskOptions(task) }
				</td>
				<td>
					{ task.required == 'YES' && t('task.required.yes')}
					{ task.required == 'NO' && t('task.required.no')}
					{ task.required == 'NO_WITH_VALID_EXPLANATION' && t('task.required.nowithvalidexplanation')}
					{ task.required == 'NO_WITH_LATER_UPLOAD' && t('task.required.nowithlaterupload')}
					{ task.required == 'NO_LATER_UPLOAD_POSSIBLE' && t('task.required.nolateruploadpossible')}
				</td>
				{ showTaskTypes() &&
					<td>
						{ task.preconditions.length > 0 &&
							<a href="#" onClick={e => {showPreconditions(e, task)}} style={{cursor: 'pointer'}}>
								{t('Visa villkor')}
							</a>
						}
					</td>
				}
				<td>
					{task.level}
				</td>
			</tr>
			{ task.type == 'GROUP' && task.expanded &&
				tasks.filter(child => child.parent == task.id).map(child => {
					return getTemplateTaskRow(child, depth + 1)
				})
			}
		</React.Fragment>
    }

    const getDocumentationTaskIcon = (documentationTask) => {
	    switch (documentationTask.type) {
			case 'PHOTO':
				return <FontAwesomeIcon icon={faCamera}/>
			case 'DRAWING':
				return <FontAwesomeIcon icon={faPaintbrush}/>
			case 'TEXT':
			case 'STATIC_TEXT':
				return <FontAwesomeIcon icon={faFont}/>
			case 'HEADER':
				return <FontAwesomeIcon icon={faHeading}/>
			case 'INTEGER':
			case 'DECIMAL':
				return <FontAwesomeIcon icon={faHashtag}/>
			case 'CHECKBOX':
				return <FontAwesomeIcon icon={faSquareCheck}/>
			case 'SINGLE_CHOICE':
			case 'MULTI_CHOICE':
			case 'SINGLE_CHOICE_SUGGESTION':
			case 'MULTI_CHOICE_SUGGESTION':
				return <FontAwesomeIcon icon={faListCheck}/>
			case 'GROUP':
				return <FontAwesomeIcon icon={faFolder}/>
			case 'FILE':
				return <FontAwesomeIcon icon={faPaperclip}/>
			case 'PREDEFINED':
				return <FontAwesomeIcon icon={faGear}/>
			case 'DATE':
			case 'DATE_RANGE':
			case 'DATE_TIME':
				return <FontAwesomeIcon icon={faCalendar}/>
			case 'TIME':
				return <FontAwesomeIcon icon={faClock}/>
			case 'CONTACT_PERSONS':
				return <FontAwesomeIcon icon={faUsers}/>
			case 'ZEBRA_SCANNER':
				return <FontAwesomeIcon icon={faBarcode}/>
			case 'MAP_MARKER':
			case 'MAP_MULTIPLE_MARKERS':
			case 'MAP_POLYGON':
				return <FontAwesomeIcon icon={faMap}/>
		}
		return <FontAwesomeIcon icon={faCamera}/>
    }

    const toggleGroup = (e, groupTask) => {
        console.log('toggleGroup')

        e.preventDefault();

        groupTask.expanded = !groupTask.expanded

		let newTasks = [...tasks]
		setTasks(newTasks)
    }

    const closeAll = (e) => {
        e.preventDefault()
        tasks.forEach(task => {
            if (task.type == 'GROUP') {
                task.expanded = false
            }
        })
        let newTasks = [...tasks]
		setTasks(newTasks)
    }

    const openAll = (e) => {
        e.preventDefault()
        tasks.forEach(task => {
            if (task.type == 'GROUP') {
                task.expanded = true
            }
        })
        let newTasks = [...tasks]
		setTasks(newTasks)
    }

    const showPreconditions = (e, task) => {
        e.preventDefault();
        setSelectedTask(task);
        setShowModal(true);
    }

    const hideModal = () => {
		setShowModal(false)
		setBackdrop(false)
    }

    const getNodeCard = node => {
        return <Card key={node.id + '-card'}>
            <Card.Header style={{ background: 'none' }}>
                {node.type}
            </Card.Header>
            { node.params && Object.entries(node.params).length > 0 &&
	            <Card.Body>
	                { node.params && Object.entries(node.params).length > 0 &&
	                    <ul>
	                        { Object.entries(node.params).map(param => {
	                            return <li key={node.id + '-' + param[0]}>
	                                {param[0]}: {formatParamValue(param[1])}
	                            </li>
	                        })}
	                    </ul>
	                }
	                { node.children && node.children.length > 0 &&
	                    <>
	                        { node.children.map(child => {
	                            return getNodeCard(child)
	                        })}
	                    </>
	                }
	            </Card.Body>
            }
        </Card>
    }

    const getPreconditionCard = (precondition, index) => {
        return <Card key={precondition.id + '-card'}>
            <Card.Header style={{ background: 'none' }}>
                {t('precondition.label')} {index + 1}
            </Card.Header>
            { precondition.params && Object.entries(precondition.params).length > 0 &&
	            <Card.Body>
	                <ul>
	                    <li>
	                        {t('precondition.columns.type')}: {precondition.type}
	                    </li>
		                { precondition.params && Object.entries(precondition.params).length > 0 &&
		                    <>
		                        { Object.entries(precondition.params).map(param => {
		                            return <li key={precondition.id + '-' + param[0]}>
		                                {param[0]}: {formatParamValue(param[1])}
		                            </li>
		                        })}
	                        </>
		                }
	                </ul>
	            </Card.Body>
            }
        </Card>
    }

    const formatParamValue = value => {
        if (typeof value == "boolean") {
            return value ? t('crudtable.yes') : t('crudtable.no')
        }
        return value
    }

    const onClickEdit = e => {
        const url = new URL(window.location.href)
		if (url.searchParams.size > 0) {
            history.push("/template/" + uuid + "?" + url.searchParams.toString())
        } else {
            history.push("/template/" + uuid)
        }
    }

    const onClickDownloadExcelFile = e => {
        window.location.href = SERVER_URL + "/template/getTemplateExcelFile/" + uuid
    }

    const showReferencePhotos = () => {
        if (authService.hasRoles(['ROLE_SUPER_ADMIN'])) {
			let customer = customers.find(customer => customer.id == template.customerId)
			if (customer) {
				let product = customer.products.find(product => product.name == "REFERENCE_PHOTO")
				if (product) {
					return true
				}
			}
            return false
        }
        return authService.hasProducts(['REFERENCE_PHOTO'])
    }

    const onChangeLeftTemplateBackup = e => {
        console.log(e.target.value)
        var templateBackup = templateBackups.find(templateBackup => templateBackup.id == e.target.value)
        setLeftTemplateBackup(templateBackup)
    }

    const onChangeRightTemplateBackup = e => {
		var templateBackup = templateBackups.find(templateBackup => templateBackup.id == e.target.value)
        setRightTemplateBackup(templateBackup)
    }

    const formatDate = function(cell) {
        if (cell) {
            return moment(cell).format('yyyy-MM-DD HH:mm')
        }
		return '-'
	}

	return (
		<div style={{marginBottom: '50px'}}>
			{ template &&
				<div style={{marginBottom: 20}}>
					<div className="clearfix">
						<div className="float-left">
							<h2>
								{ template.name }
				            </h2>
			            </div>
			            <div className="float-right">
			                <Button
					            onClick={onClickEdit}
					            title={t('crudtable.edit')}
					            color="info"
					            variant="outline-secondary">
					            <FontAwesomeIcon icon={faEdit}/> {t('crudtable.edit')}
					        </Button>
					        { authService.hasRoles(['ROLE_SUPER_ADMIN']) &&
						        <Button
						            onClick={onClickDownloadExcelFile}
						            title={t('crudtable.edit')}
						            color="info"
						            variant="outline-secondary"
						            style={{ marginLeft: 5 }}>
						            <FontAwesomeIcon icon={faFileExcel}/> Ladda ner översättningsfil
						        </Button>
					        }
			            </div>
		            </div>
		            <Row className={styles.templateDetails}>
		                <Col xl="3">
		                    <div>
			                    <label>
			                        {t('template.columns.datecreated')}
			                    </label>
			                    { formatDate(template.dateCreated) }
		                    </div>
		                    <div>
			                    <label>
			                        {t('template.columns.lastupdated')}
			                    </label>
			                    { formatDate(template.lastUpdated) }
		                    </div>
		                    <div>
			                    <label>
			                        {t('template.columns.description')}
			                    </label>
			                    { template.description || '-' }
		                    </div>
		                    <div>
			                    <label>
			                        {t('template.columns.hidden')}
			                    </label>
			                    { template.hidden ? t('crudtable.yes') : t('crudtable.no') }
		                    </div>
		                    <div>
			                    <label>
			                        {t('template.columns.exportdocumenttypes')}
			                    </label>
			                    { template.exportDocumentTypes.length > 0 &&
	                                <>
	                                    { template.exportDocumentTypes.map(exportDocumentType => {
	                                        return <span key={exportDocumentType}>{exportDocumentType}</span>
	                                    })}
	                                </>
	                            }
	                            { template.exportDocumentTypes.length == 0 &&
	                                <>-</>
	                            }
		                    </div>
		                    <div>
			                    <label>
			                        {t('template.columns.exportdocumentconfigurations')}
			                    </label>
			                    { template.exportDocumentConfigurations.length > 0 &&
	                                <>
	                                    {template.exportDocumentConfigurations.map(exportDocumentConfiguration => {
	                                        return exportDocumentConfiguration.name
	                                    }).join(", ")}
	                                </>
	                            }
	                            { template.exportDocumentConfigurations.length == 0 &&
	                                <>-</>
	                            }
		                    </div>
		                </Col>
		                <Col xl="3">
		                    <div>
			                    <label>
			                        {t('template.columns.includeexternalfiles')}
			                    </label>
			                    { template.includeExternalFiles ? t('crudtable.yes') : t('crudtable.no') }
		                    </div>
		                    <div>
			                    <label>
			                        {t('template.columns.locationenabled')}
			                    </label>
			                    { template.locationEnabled ? t('crudtable.yes') : t('crudtable.no') }
		                    </div>
		                    <div>
			                    <label>
			                        {t('template.columns.locationrequired')}
			                    </label>
			                    { template.locationRequired ? t('crudtable.yes') : t('crudtable.no') }
		                    </div>
				            <div>
			                    <label>
			                        {t('template.columns.deleteautomatically')}
			                    </label>
			                    { template.deleteAutomatically ? t('crudtable.yes') : t('crudtable.no') }
		                    </div>
		                    <div>
			                    <label>
			                        {t('template.columns.deletetimelimit')}
			                    </label>
			                    { template.deleteTimeLimit || '-' }
		                    </div>
	                    </Col>
			            <Col xl="3">
		                    <div>
			                    <label>
			                        {t('template.columns.position')}
			                    </label>
			                    { template.position }
		                    </div>
		                    <div>
			                    <label>
			                        {t('template.columns.suggestionlist')}
			                    </label>
			                    { template.suggestionListName }
		                    </div>
		                    <div>
			                    <label>
			                        {t('template.columns.onlysuggestionsallowed')}
			                    </label>
			                    { template.onlySuggestionsAllowed ? t('crudtable.yes') : t('crudtable.no') }
		                    </div>
		                    <div>
			                    <label>
			                        {t('template.columns.graphicenabled')}
			                    </label>
			                    { template.graphicEnabled ? t('crudtable.yes') : t('crudtable.no') }
		                    </div>
		                    <div>
			                    <label>
			                        {t('template.columns.predefinedenabled')}
			                    </label>
			                    { template.predefinedEnabled ? t('crudtable.yes') : t('crudtable.no') }
		                    </div>
				        </Col>
				    </Row>
	            </div>
			}
			{ template &&
				<>
					<Tabs style={{paddingTop: '10px'}}>
						<Tab eventKey="tasks" title={t('template.tabs.tasks')} style={{paddingTop: '10px'}}>
							{ showTaskTypes() && tasks.some(task => task.type == 'GROUP') &&
								<>
									<Button
							            onClick={openAll}
							            size="md"
							            color="info"
							            variant="outline-primary">
							            {t('template.openall')}
							        </Button>
									<Button
							            onClick={closeAll}
							            size="md"
							            color="info"
							            variant="outline-primary"
							            style={{marginRight: '5px'}}>
							            {t('template.closeall')}
							        </Button>
						        </>
					        }
							<table className="table border">
								<thead>
									<tr>
										<th>
											{t('task.columns.name')}
										</th>
										<th>
											{t('task.columns.key')}
										</th>
										<th>
											{t('task.columns.description')}
										</th>
										{ showReferencePhotos() &&
											<th>
												{t('task.columns.referencephotos')}
											</th>
										}
										<th>
											{t('task.columns.options')}
										</th>
										<th>
											{t('task.columns.required')}
										</th>
										{ showTaskTypes() &&
											<>
												<th>
													{t('task.columns.preconditions')}
												</th>
											</>
										}
										<th>
											{t('task.columns.level')}
										</th>
									</tr>
								</thead>
								<tbody>
									{ tasks.filter(task => task.parent == null).map(task => {
										return getTemplateTaskRow(task, 0)
									})}
								</tbody>
							</table>
						</Tab>
						{ template.replacementTexts.length > 0 &&
							<Tab eventKey="replacementTexts" title={t('template.tabs.replacementtexts')} style={{paddingTop: '10px'}}>
								<table className="table">
									<thead>
										<tr>
											<th>
												{t('template.replacementtext.code')}
											</th>
											<th>
												{t('template.replacementtext.swedish')}
											</th>
											<th>
												{t('template.replacementtext.english')}
											</th>
										</tr>
									</thead>
									<tbody>
										{ template.replacementTexts.map(replacementText => {
											return <tr key={replacementText.id}>
												<td>
													{replacementText.code}
												</td>
												<td>
													{replacementText.translations['SV']}
												</td>
												<td>
													{replacementText.translations['EN']}
												</td>
											</tr>
										})}
									</tbody>
								</table>
							</Tab>
						}
						{ template.templateExportConfigurations.length > 0 &&
							<Tab eventKey="export" title={t('template.tabs.export')} style={{paddingTop: '10px'}}>
								<Row>
									<Col xl="12">
	                                    { template.templateExportConfigurations.sort((a, b) => a.position - b.position).map(templateExportConfiguration => {
	                                        return <Card key={templateExportConfiguration.id} style={{marginBottom: '10px'}}>
												<Card.Header style={{ background: 'none' }}>
													<h4 style={{ marginBottom: 0 }}>
														{templateExportConfiguration.name || templateExportConfiguration.exportConfigurationName}
													</h4>
													{templateExportConfiguration.exportConfigurationType}
												</Card.Header>
												<Card.Body>
		                                            { templateExportConfiguration.params &&
		                                                <ul>
		                                                    { Object.entries(templateExportConfiguration.params).map(param => {
				                                                return <li key={templateExportConfiguration.id + '-' + param[0]}>
				                                                    {param[0]}: {formatParamValue(param[1])}
				                                                </li>
				                                            })}
		                                                </ul>
		                                            }
		                                            { templateExportConfiguration.nodes.map(node => {
		                                                return getNodeCard(node)
		                                            })}
		                                            { templateExportConfiguration.preconditions.map((precondition, index) => {
		                                                return getPreconditionCard(precondition, index)
		                                            })}
	                                            </Card.Body>
	                                        </Card>
	                                    })}
							        </Col>
						        </Row>
							</Tab>
						}
						{ templateBackups.length > 0 && leftTemplateBackup && rightTemplateBackup &&
							<Tab eventKey="backups" title={t('template.tabs.backups')} style={{paddingTop: '10px'}}>
								<Row className={styles.templateDetails}>
									<Col sm="6">
										<select className="form-control" id="leftTemplateBackup" value={leftTemplateBackup.id} onChange={onChangeLeftTemplateBackup}>
											{ templateBackups.map(templateBackup => {
												return <option
													value={templateBackup.id}
													key={'left-' + templateBackup.id}
													disabled={templateBackup.id == rightTemplateBackup.id}
												>
													{formatDate(templateBackup.dateCreated)}
												</option>
											})}
										</select>
									</Col>
									<Col sm="6">
										<select className="form-control" id="rightTemplateBackup" value={rightTemplateBackup.id} onChange={onChangeRightTemplateBackup}>
											{ templateBackups.map(templateBackup => {
												return <option
													value={templateBackup.id}
													key={'right-' + templateBackup.id}
													disabled={templateBackup.id == leftTemplateBackup.id}
												>
													{formatDate(templateBackup.dateCreated)}
												</option>
											})}
										</select>
									</Col>
									<Col sm="12">
										<ReactDiffViewer
											oldValue={JSON.stringify(JSON.parse(leftTemplateBackup.json), null, 2)}
											newValue={JSON.stringify(JSON.parse(rightTemplateBackup.json), null, 2)}
											splitView={true}
											showDiffOnly={false}
											style={{fontFamily: 'monospace'}}
											compareMethod={DiffMethod.JSON}
                                        />
									</Col>
								</Row>
							</Tab>
						}
					</Tabs>
					<Modal
						style={{overflow: 'scroll'}}
						size="lg"
						show={showModal}
						backdrop={backdrop}
						onShow={() => console.log('onShow')}
						onHide={hideModal}
						animation={false}>
						<Modal.Header closeButton>
							<Modal.Title>
								{selectedTask ? selectedTask.name : ''}
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<Row>
								{ selectedTask && selectedTask.preconditions.map((precondition, index) => {
									return <Col sm={4} key={precondition.id}>
										<Card>
											<Card.Header style={{ background: 'none' }}>
												{t('precondition.label')} {index + 1}
											</Card.Header>
											<Card.Body>
												<label style={{fontWeight: 'bold'}}>
													{t('precondition.columns.type')}
												</label>
												<div>
													{ precondition.type == 'TASK_ANSWER' && t('precondition.types.taskanswer')}
													{ precondition.type == 'TASK_PHOTOS_TAKEN' && t('precondition.types.taskphotostaken')}
													{ precondition.type == 'TASK_NO_PHOTOS_TAKEN' && t('precondition.types.tasknophotostaken')}
													{ precondition.type == 'PLATFORM' && t('precondition.types.platform')}
													{ precondition.type == 'TASK_FINISHED' && t('precondition.types.taskfinished')}
													{ precondition.type == 'TASK_UNFINISHED' && t('precondition.types.taskunfinished')}
													{ precondition.type == 'TASK_ANSWER_INCLUDES' && t('precondition.types.taskanswerincludes')}
												</div>
								                { precondition.type == 'TASK_ANSWER' &&
								                    <>
								                        <label style={{fontWeight: 'bold'}}>
															{t('precondition.params.task')}
														</label>
														<div>
															{ tasks.find(otherTask => otherTask.id == precondition.params.TASK_ID).name }
														</div>
										                <label style={{fontWeight: 'bold'}}>
															{t('precondition.params.operator')}
														</label>
														<div>
															{ precondition.params.OPERATOR == 'EQUALS' && t('precondition.operators.equals')}
															{ precondition.params.OPERATOR == 'NOT_EQUALS' && t('precondition.operators.notequals')}
														</div>
										                <label style={{fontWeight: 'bold'}}>
															{t('precondition.params.answer')}
														</label>
														<div>
															{precondition.params.ANSWER}
														</div>
													</>
							                    }
							                    { (precondition.type == 'TASK_PHOTOS_TAKEN' || precondition.type == 'TASK_NO_PHOTOS_TAKEN') &&
								                    <>
								                        <label style={{fontWeight: 'bold'}}>
															{t('precondition.params.task')}
														</label>
														<div>
															{ tasks.find(otherTask => otherTask.id == precondition.params.TASK_ID).name }
														</div>
							                        </>
							                    }
							                    { precondition.type == 'PLATFORM' &&
								                    <>
										                <label style={{fontWeight: 'bold'}}>
															{t('precondition.params.operator')}
														</label>
														<div>
															{ precondition.params.OPERATOR == 'EQUALS' && t('precondition.operators.equals')}
															{ precondition.params.OPERATOR == 'NOT_EQUALS' && t('precondition.operators.notequals')}
														</div>
										                <label style={{fontWeight: 'bold'}}>
															{t('precondition.params.platform')}
														</label>
														<div>
															{ precondition.params.PLATFORM }
														</div>
													</>
							                    }
							                    { (precondition.type == 'TASK_FINISHED' || precondition.type == 'TASK_UNFINISHED') &&
								                    <>
								                        <label style={{fontWeight: 'bold'}}>
															{t('precondition.params.task')}
														</label>
													</>
							                    }
							                    { precondition.type == 'TASK_ANSWER_INCLUDES' &&
								                    <>
								                        <label style={{fontWeight: 'bold'}}>
															{t('precondition.params.task')}
														</label>
														<div>
															{ tasks.find(otherTask => otherTask.id == precondition.params.TASK_ID).name }
														</div>
										                <label style={{fontWeight: 'bold'}}>
															{t('precondition.params.answer')}
														</label>
														<div>
															{ precondition.params.ANSWER }
														</div>
													</>
							                    }
							                </Card.Body>
										</Card>
									</Col>
								})}
							</Row>
						</Modal.Body>
						<Modal.Footer>
							<Button
					            onClick={hideModal}
					            size="md"
					            color="info"
					            variant="primary">
					            {t('crudtable.ok')}
					        </Button>
						</Modal.Footer>
					</Modal>
				</>
			}
        </div>
    )
}

export default TemplateDetails;